(function ($) {
  $('.home-rotator').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
  });
})(window.jQuery);
